import React from "react";
import { Container } from "react-bootstrap";

const ReportAnIssue = () => {
  return (
    <Container>
      <h4>Need more help?</h4>
      <p>
        Please contact your <b>McKinsey engagement team</b>.
      </p>
    </Container>
  );
};

export default ReportAnIssue;
